<template>
  <div>
    <GlobalHeader />
    <div class="categoryHead">
      <div class="inner">
        <nav class="categoryHeadArea">
          <ul class="specials">
            <template v-if="!isDemo()">
              <li v-for="special of specialExhibitions" :key="special.id"><router-link :to="`/specials/${special.id}`" :class="{ location: isSelected(`/specials/${special.id}`) }">{{ special.shortName ? special.shortName : special.name }}</router-link></li>
            </template>
          </ul>
        </nav>
      </div><!-- /inner-->
    </div><!-- /categoryHead-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GlobalHeader from './GlobalHeader'

export default {
  components: {
    GlobalHeader
  },
  methods: {
    isDemo () {
      return process.env.VUE_APP_DEMO_HOST ? (location.host.indexOf(process.env.VUE_APP_DEMO_HOST) >= 0) : false
    },
    isSelected (str) {
      return this.$route.path.indexOf(str) >= 0
    }
  },
  computed: {
    ...mapGetters([
      'specialExhibitions'
    ])
  },
  mounted () {
  }
}
</script>
